const initialState = {
    wins: 0,
    losses: 0,
    draws: 0,
    totalPoints: 0,
    winStreak: 0,
    maxWinStreak: 0,
    badges: [] // ['novice', 'warrior', etc]
};

export default function battle(state = initialState, action) {
    switch (action.type) {
        case 'BATTLE_WIN':
            const newWinStreak = state.winStreak + 1;
            return {
                ...state,
                wins: state.wins + 1,
                totalPoints: state.totalPoints + (action.payload.points || 50),
                winStreak: newWinStreak,
                maxWinStreak: Math.max(state.maxWinStreak, newWinStreak)
            };
        case 'BATTLE_LOSS':
            return {
                ...state,
                losses: state.losses + 1,
                winStreak: 0
            };
        case 'BATTLE_DRAW':
            return {
                ...state,
                draws: state.draws + 1,
                totalPoints: state.totalPoints + (action.payload.points || 10),
                winStreak: 0
            };
        case 'ADD_BADGE':
            if (state.badges.includes(action.payload)) return state;
            return {
                ...state,
                badges: [...state.badges, action.payload]
            };
        case 'RESET_BATTLE_STATS':
            return initialState;
        default:
            return state;
    }
}
